import { useEffect, useState } from 'react';

import {
  getLoadedDateLocale,
  loadDateLocale,
} from '@/shared/libs/load-date-locale';

export const useDateLocale = (locale: string) => {
  const [, setDateLocale] = useState(() => getLoadedDateLocale(locale));

  useEffect(() => {
    if (getLoadedDateLocale(locale)) return;

    let isActive = true;
    loadDateLocale(locale).then((dateLocale) => {
      if (isActive) setDateLocale(dateLocale);
    });

    return () => {
      isActive = false;
    };
  }, [locale]);

  return getLoadedDateLocale(locale);
};
